export default "__VITE_ASSET__f8x$aY6T__"